export function formatPhoneDisplay(phone: string): string {
  const d = phone.replace(/\D/g, "");
  const normalized = d.length === 11 && d.startsWith("1") ? d.slice(1) : d;
  if (normalized.length === 10) {
    return `+1 (${normalized.slice(0, 3)}) ${normalized.slice(3, 6)}-${normalized.slice(6)}`;
  }
  return phone;
}
